import React from 'react'
import {
  Grid,  Typography, Card, CardContent, Avatar } from '@mui/material'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'

const TargetsSection = ({
  lotTargetFields = [],
  assumptions,
  netProfit,
  analytics }) => (
  <>
    <Grid container style={{ marginTop: 20 }}>
      <Grid size={12}>
        <Typography variant="h6">Targets</Typography>
      </Grid>
    </Grid>
    <Grid
      container
      direction="row"
      spacing={1}
      style={{ marginBottom: 10 }}
    >
      {(lotTargetFields || []).map((field, idx) => (
        <Grid size={{xs: field.xs, sm: field.sm}} key={idx}>
          <Card>
            <CardContent>
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "space-between"
                }}
              >
                <Grid data-hf-grid="keep">
                  <Typography>{field.label}:</Typography>
                </Grid>
                <Grid data-hf-grid="keep">
                  <Grid
                    container
                    direction="row"
                    spacing={1}
                    sx={{
                      alignItems: "center"
                    }}
                  >
                    {field.label === 'Net Profit' && (
                      <Grid data-hf-grid="keep">
                        {(assumptions?.belowB2RNetProfit ?? 0) >
                        (netProfit ?? 0) ? (
                          <Avatar
                            style={{
                              backgroundColor: '#F05248',
                              height: 15,
                              width: 15}}
                          >
                            <ArrowDownwardIcon
                              style={{
                                color: 'white',
                                fontSize: 'small'}}
                            />
                          </Avatar>
                        ) : (
                          <Avatar
                            style={{
                              backgroundColor: '#46de64',
                              height: 15,
                              width: 15}}
                          >
                            <ArrowUpwardIcon
                              style={{
                                color: 'white',
                                fontSize: 'small'}}
                            />
                          </Avatar>
                        )}
                      </Grid>
                    )}
                    {field.label === 'Cap Rate' && (
                      <Grid data-hf-grid="keep">
                        {(assumptions?.belowB2RCapRate ?? 0) >
                        (analytics?.B2R?.capRateB2R ?? 0) * 100 ? (
                          <Avatar
                            style={{
                              backgroundColor: '#F05248',
                              height: 15,
                              width: 15}}
                          >
                            <ArrowDownwardIcon
                              style={{
                                color: 'white',
                                fontSize: 'small'}}
                            />
                          </Avatar>
                        ) : (
                          <Avatar
                            style={{
                              backgroundColor: '#46de64',
                              height: 15,
                              width: 15}}
                          >
                            <ArrowUpwardIcon
                              style={{
                                color: 'white',
                                fontSize: 'small'}}
                            />
                          </Avatar>
                        )}
                      </Grid>
                    )}
                    <Grid data-hf-grid="keep">
                      <Typography>
                        {field.label === 'Cap Rate'
                          ? field.value.toLocaleString(undefined, {
                              style: 'percent',
                              minimumFractionDigits: 2 })
                          : field.decimal
                            ? field.value.toLocaleString(undefined, {
                                style: 'currency',
                                currency: 'USD',
                                minimumFractionDigits: 2 })
                            : field.value.toLocaleString(undefined, {
                                style: 'currency',
                                currency: 'USD',
                                minimumFractionDigits: 0})}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </>
)

export default TargetsSection
